import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the AuthStore provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ConstantsStore {

  private _data:object;
  set data(data:object){
    this._data = data;
  }
  get data(){
    return this._data;
  }
}


// WEBPACK FOOTER //
// ./src/stores/constants-store.ts